import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";

/**
 * Footer component
 * Displays footer links including privacy policy, terms, and contact information
 * Accessible and responsive across all screen sizes
 */
export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full border-t bg-background mt-auto" role="contentinfo">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Brand */}
          <div className="text-center md:text-left">
            <p className="text-sm text-muted-foreground">
              © {currentYear} Scope Manager. All rights reserved.
            </p>
          </div>

          {/* Footer Links */}
          <nav className="flex flex-wrap justify-center gap-6" aria-label="Footer navigation">
            <Link
              to="/privacy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline"
            >
              Privacy Policy
            </Link>
            <Separator orientation="vertical" className="h-4 hidden md:block" />
            <Link
              to="/terms"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline"
            >
              Terms of Service
            </Link>
            <Separator orientation="vertical" className="h-4 hidden md:block" />
            <a
              href="mailto:privacy@scopemanager.ai"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline"
            >
              Contact
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
